import React from 'react';
import DiscountManagement from './DiscountManagement';

const Discounts: React.FC = () => {
  return <DiscountManagement />;
};

export default Discounts;
